import React, { useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../css/my-mailings.css';
import useLocalStorageList from '../hooks/useLocalStorageList';

const typeMap = {
    test: 'тестовая',
    prod: 'основная',
};

export default function MyMailings({ newMailing, project }) {
    const { list, handleClearList, handleAddItem } = useLocalStorageList(`my-mailings-${project}`);

    useEffect(() => {
        if (
            !newMailing
            || list.find((mailing) => `${mailing.time}-${mailing.type}` === `${newMailing.time}-${newMailing.type}`)
        ) {
            return;
        }

        handleAddItem(newMailing);
    }, [newMailing]);

    return (
        <div className="my-mailings">
            <h2 className="my-mailings__title">
                Мои рассылки
                <button className="my-mailings__clear">
                    <FontAwesomeIcon className="my-mailings__clear-icon" icon="trash" onClick={handleClearList} />
                </button>
            </h2>
            <div className="my-mailings__list">
                {list.length ? list.map((item) => (
                    <div className="my-mailings__item" key={item.time}>
                        <p className="my-mailings__time">
                            <span className="my-mailings__emoji">{item.emoji}</span>
                            {item.time}
                        </p>
                        <p className="my-mailings__type">
                            {typeMap[item.type]}
                            {' '}
                            рассылка
                        </p>
                    </div>
                )) : (
                    <p className="my-mailings__time">Тут пока пусто 😶</p>
                )}
            </div>
        </div>
    );
}

MyMailings.defaultProps = {
    project: 'p1',
};
